import React, { useEffect } from "react";
import OrganizationModel from "src/models/OrganizationModel";
import UserModel from "src/models/UserModel";
import { AddUserFormValues } from "src/routes/admin/users/AddUser";
import { useStore } from "src/stores/Store";
import { UseFormHook } from "../forms/Form";
import InputCheckbox from "../inputs/InputCheckbox";

interface Props {
  user: UserModel;
  organization?: OrganizationModel;
  form: UseFormHook<AddUserFormValues>;
}

export default function UserDepartments(props: Props) {
  const store = useStore();

  useEffect(() => {
    if (!props.user.id) {
      organization.departments.forEach((d) => {
        props.form.setFieldsValue({ [`department-${d.id}`]: true });
      });
    }
  }, []);

  let organization = store.organization;

  if (props.organization) {
    organization = props.organization;
  }

  const assignedDepartments = Object.keys(props.form.getFieldsValue()).filter(
    (k) => k.startsWith("department-") && props.form.getFieldValue(k)
  );

  console.log("assignedDepartments", assignedDepartments);

  return (
    <React.Fragment>
      <p>
        {props.user.firstName} will be able to view any profile or account, but
        will only see offerings and schedules associated with the departments to
        which they are assigned.
      </p>
      <hr />
      <InputCheckbox
        checked={
          assignedDepartments.length === store.organization.departments.length
        }
        disabled={props.form.isSubmitting}
        className="mb-3 items-center"
        onChange={(checked) => {
          if (checked) {
            store.organization.departments.forEach((d) => {
              props.form.setFieldsValue({ [`department-${d.id}`]: true });
            });
          } else {
            store.organization.departments.forEach((d) => {
              props.form.setFieldsValue({ [`department-${d.id}`]: false });
            });
          }
        }}
      >
        <strong>Assign to all departments</strong>
      </InputCheckbox>

      <div className="pl-5">
        {organization.departments.map((d) => {
          return (
            <div key={d.id} className="mb-3">
              {props.form.getFieldDecorator(`department-${d.id}`, {
                initialValue: !!props.user.departments.find(
                  (ud) => ud.id === d.id
                ),
                valuePropName: "checked",
              })(
                <InputCheckbox
                  disabled={props.form.isSubmitting}
                  className="items-center"
                >
                  {d.title}
                </InputCheckbox>
              )}
            </div>
          );
        })}
      </div>

      <hr className="mb-8" />
    </React.Fragment>
  );
}
